import React, { Fragment, useContext, useEffect } from 'react'

import useIsMounted from '@hooks/useIsMounted'
import { OptionsContext } from './provider'
import CommonService from '@services/common/common.service'
import { AuthContext } from '@contexts/Auth'

interface Props {
	children: React.ReactNode
}

const promiseList: {
    dispatchAction:  'updateProduct' | 'updateContract' | 'updateProject' | 'updateProjectGroup' |
    'updateModule' | 'updateProfile' | 'updateRole' | 'updateOrganization',
    target: string
}[] = [
    {
        dispatchAction: 'updateProduct',
        target: 'product'
    },
    // {
    //     dispatchAction: 'updateContract',
    //     target: 'contract'
    // },
    {
        dispatchAction: 'updateProject',
        target: 'project'
    },
    {
        dispatchAction: 'updateProjectGroup',
        target: 'project_group'
    },
    {
        dispatchAction: 'updateModule',
        target: 'module'
    },
    {
        dispatchAction: 'updateProfile',
        target: 'profile'
    },
    {
        dispatchAction: 'updateRole',
        target: 'role'
    },
    {
        dispatchAction: 'updateOrganization',
        target: 'organization'
    },
]

const OptionsWrapper: React.FC<Props> = ({ children }) => {
    const { state, dispatch } = useContext(OptionsContext)
    const { state: userState } = useContext(AuthContext)

	useEffect(() => {
        if( userState.completedInitiated ){
            try {
                promiseList.forEach(async (x) => {
                    await CommonService.GetCategoryMetadata(x.target).then((results) => {
                        dispatch({type: x.dispatchAction, options: results})
                    })
                })
            } catch (e: any) {
                console.log('[Error] Failed to fetch options', e?.message)
            }
        }
	}, [userState])

	return <Fragment>{children}</Fragment>
}

export default OptionsWrapper
